import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useProfileCompleteness } from "@/contexts/ProfileCompletenessContext";
import { AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";

export function ProfileCompletenessIndicator() {
  const { score, shouldShowNudge } = useProfileCompleteness();

  if (!shouldShowNudge || !score || score.overall >= 90) return null;

  const getIndicatorColor = (score: number) => {
    if (score >= 80) return "bg-yellow-500";
    if (score >= 60) return "bg-orange-500";
    return "bg-red-500";
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="sm" asChild className="relative">
            <Link to="/profile">
              <AlertCircle className="h-4 w-4" />
              <div
                className={`absolute -top-1 -right-1 w-2 h-2 rounded-full ${getIndicatorColor(score.overall)} animate-pulse`}
              />
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <div className="space-y-2">
            <p className="font-medium">Profile {score.overall}% Complete</p>
            <p className="text-sm text-muted-foreground">
              {score.suggestions.length > 0
                ? score.suggestions[0]
                : "Complete your profile to unlock all features"}
            </p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
